const updates = [
  { date: '07-29', title: '鬼灭之刃 无限城篇 第5话更新', tag: '日漫更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-29', title: '斗罗大陆2绝世唐门 第218话上线', tag: '国漫更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-28', title: '我独自升级 第二季 第16话发布', tag: '韩漫改编', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-28', title: '完美世界 第185话 神战开启', tag: '国漫更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-27', title: '间谍过家家 第三季 第9话上线', tag: '日漫更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '凡人修仙传 第156话 突破元婴', tag: '国漫更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-26', title: '咒术回战 涩谷事变篇 全篇上线', tag: '重磅上线', tagColor: 'bg-primary-500 text-background-50' },
  { date: '07-26', title: '星辰变 第五季 第42话更新', tag: '国漫更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '仙逆 年番 第98话 逆天改命', tag: '国漫更新', tagColor: 'bg-accent-100 text-accent-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">更新快讯</h2>
          <p className="mt-3 text-sm text-foreground-600">最新番剧更新动态，第一时间了解动漫圈新鲜事</p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="relative">
            <div className="absolute left-[23px] top-0 bottom-0 w-px bg-background-300"></div>
            <div className="flex flex-col gap-4">
              {updates.map((item, idx) => (
                <div key={idx} className="flex items-start gap-4 pl-[54px] relative">
                  <div className="absolute left-[18px] top-2 w-[11px] h-[11px] rounded-full bg-primary-500 border-2 border-background-100"></div>
                  <div className="flex-1 bg-background-50 rounded-xl p-4 border border-background-200/70 transition-all hover:-translate-x-1 cursor-pointer">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <span className="text-[10px] text-foreground-500 font-medium whitespace-nowrap">{item.date}</span>
                      <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                    </div>
                    <p className="text-sm text-foreground-800">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}